// Imports
import Vue from 'vue'
import Router from 'vue-router'
import { trailingSlash } from '@/util/helpers'
import store from '../store'
import { dispatch } from 'vuex-pathify'
import routes from './routes'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/', // process.env.BASE_URL,
  linkExactActiveClass: 'is-active',
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash }
    if (savedPosition) return savedPosition

    return { x: 0, y: 0 }
  },
  routes: routes(),
})

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    const isLoggedIn = store.get('auth/logged_in')
    const profile = store.get('auth/profile')
    // console.log(to.path)
    if (
      (
        to.path.match('/flight/general')
      ) && profile.organization.planes_all.filter(p => p.plane_category_id === 'plc_01').length === 0
    ) {
      next({
        path: '/error/no_aircraft_available',
      })
    }
    if (
      (
        to.path.match('/flight/glider')
      ) && profile.organization.planes.filter(p => p.plane_category_id === 'plc_02').length === 0
    ) {
      next({
        path: '/error/no_aircraft_available',
      })
    }
    if (
      (
        to.path.match('/reservations')
      ) && profile.organization.planes.filter(p => p.rentable === 1 && p.functional === 1).length === 0
    ) {
      next({
        path: '/error/no_rentable_aircraft_available',
      })
    }

    if (!isLoggedIn || profile == null) {
      try {
        await store.dispatch('auth/check', { to: to, from: from })
        const { profile } = await store.dispatch('auth/checkProfile')
        // check if the user has the correct role
        if (to.meta.role) {
          if (profile.has_role[to.meta.role]) {
            next()
          } else {
            alert('Missing permissions!')
          }
        } else if (to.meta.can) {
          if (profile.can[to.meta.can]) {
            next()
          } else {
            alert('Missing permissions!')
          }
        }
        next()
      } catch (e) {
        console.log(e)
        next({
          path: '/login',
        })
      }
    } else {
      // check if the user has the correct role
      if (to.meta.role) {
        if (profile.has_role[to.meta.role]) {
          next()
        } else {
          dispatch('alert/setSnackbar', { text: 'missing_permissions', type: 'error' })
          try {
            next({
              path: '/',
            })
          } catch (e) {
            console.log(e)
          }
        }
      } else {
        next()
      } if (to.meta.can) {
        if (profile.can[to.meta.can]) {
          next()
        } else {
          dispatch('alert/setSnackbar', { text: 'missing_permissions', type: 'error' })
          try {
            next({
              path: '/',
            })
          } catch (e) {
            console.log(e)
          }
        }
      } else {
        next()
      }
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    if (store.getters.isLoggedIn) {
      next({
        path: '/',
      })
    }
  }

  return to.path.endsWith('/') ? next() : next(trailingSlash(to.path))
})

export default router
